<template>
    <el-radio-group :value="value" class="radio-option-cards" @input="val => $emit('input', val)" @change="onChange">
        <el-radio
            v-for="(item, index) in paymentTypeOptions"
            :label="item.key"
            :key="item.key"
            :id="'payment-add-page-type-' + index" border
            :disabled="isProjectOnly ? item.key !== 2 : item.key === 2">
            <el-tooltip
                effect="dark"
                placement="top"
                :content="isProjectOnly ? '所選勞報單已設定為專案勞務' : '所選勞報單非專案勞務'"
                :manual="isProjectOnly ? item.key === 2 : item.key !== 2">
                <div>
                    <div class="icon">
                        <i :class="`el-icon-${item.icon}`"></i>
                    </div>
                    <div class="title">{{ item.value }}</div>
                    <div class="intro">
                        {{ item.intro }}
                        <ah-tip v-if="item.tip">{{ item.tip }}</ah-tip>
                    </div>
                </div>
            </el-tooltip>
        </el-radio>
    </el-radio-group>
</template>
<script>
import {
    paymentType,
} from '@/assets/commonData/options';

export default {
    name: 'payment-type-select',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        isProjectOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        // 請款單類型選項
        paymentTypeOptions() {
            return paymentType.filter((x) => x.key === 1 || x.key === 2 || x.key === 3 || x.key === 4);
        },
    },
    methods: {
        onChange() {
            this.$emit('change');
        },
    },
};
</script>
